import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ProgressBar({ percentage, warningThreshold = 80, size = 'md', showLabel = true, }) {
    const clampedPercentage = Math.min(Math.max(percentage, 0), 100);
    // Determine color based on percentage and threshold
    const getColor = () => {
        if (clampedPercentage >= 100)
            return 'bg-red-600';
        if (clampedPercentage >= warningThreshold)
            return 'bg-amber-500';
        return 'bg-green-600';
    };
    const getBackgroundColor = () => {
        if (clampedPercentage >= 100)
            return 'bg-red-100';
        if (clampedPercentage >= warningThreshold)
            return 'bg-amber-100';
        return 'bg-green-100';
    };
    const heights = {
        sm: 'h-1.5',
        md: 'h-2.5',
        lg: 'h-4',
    };
    return (_jsxs("div", { className: "w-full", children: [_jsx("div", { className: `w-full ${getBackgroundColor()} rounded-full overflow-hidden ${heights[size]}`, children: _jsx("div", { className: `${getColor()} ${heights[size]} rounded-full transition-all duration-300`, style: { width: `${clampedPercentage}%` } }) }), showLabel && (_jsxs("div", { className: "mt-1 text-xs text-gray-600", children: [clampedPercentage.toFixed(1), "%"] }))] }));
}
//# sourceMappingURL=ProgressBar.js.map